"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _product = require("@/api/product");
var _hotel = require("@/api/hotel");
var _permission = require("@/utils/permission");
var _vuex = require("vuex");
var _storeEdit = _interopRequireDefault(require("./components/storeEdit"));
var _roomTpye = _interopRequireDefault(require("./components/roomTpye.vue"));
var _productEnums = require("@/enums/productEnums");
var $constants = _interopRequireWildcard(require("@/utils/constants"));
var _public = require("@/libs/public");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var tableFroms = {
  page: 1,
  limit: $constants.page.limit[0],
  type: ''
};
var _default = exports.default = {
  name: 'roomTypeList',
  directives: {
    // 计算是否滚动到最下面
    selectLoadMore: {
      bind: function bind(el, binding) {
        // 获取element-ui定义好的scroll盒子
        var SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          if (this.scrollHeight - this.scrollTop < this.clientHeight + 1) {
            binding.value();
          }
        });
      }
    }
  },
  components: {
    storeEdit: _storeEdit.default,
    roomTpye: _roomTpye.default
  },
  data: function data() {
    return {
      merId: JSON.parse(_jsCookie.default.get('JavaMerInfo')).id,
      roomTypeOptions: {},
      productTypeList: [],
      //酒店类型
      drawer: false,
      direction: 'rtl',
      propsPlant: {
        children: 'childList',
        label: 'name',
        value: 'id',
        multiple: false,
        emitPath: false
      },
      propsMer: {
        children: 'childList',
        label: 'name',
        value: 'id',
        multiple: false,
        emitPath: false,
        checkStrictly: true
      },
      headeNum: [],
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: Object.assign({}, tableFroms),
      keyword: '',
      categoryList: [],
      objectUrl: process.env.VUE_APP_BASE_API,
      card_select_show: false,
      checkAll: false,
      checkedCities: ['ID', '展示图', '房型名称', '售价', '酒店分类', '面积', '床型', '窗户', 'WIFI', '禁烟', '房间数'],
      columnData: ['ID', '展示图', '房型名称', '售价', '酒店分类', '面积', '床型', '窗户', 'WIFI', '禁烟', '房间数'],
      isIndeterminate: true,
      productId: 0,
      stockEdit: false,
      multipleSelectionAll: [],
      checkedIds: [],
      //选中的id
      ruleValidate: {
        tempId: [{
          required: true,
          message: '请选择运费模板',
          trigger: 'change'
        }]
      },
      formValidate: {
        tempId: ''
      },
      loadingBtn: false,
      dialogVisible: false,
      dialogCommision: false,
      //佣金弹窗
      commisionForm: {
        brokerage: 0,
        brokerageTwo: 0,
        id: 0,
        idList: []
      },
      //设置佣金表单
      commisionRule: {
        brokerage: [{
          required: true,
          message: '请输入一级佣金',
          trigger: 'change'
        }],
        brokerageTwo: [{
          required: true,
          message: '请输入二级佣金',
          trigger: 'change'
        }]
      },
      keyNum: 0,
      couponIds: [],
      //优惠券集合
      productInfo: null,
      //酒店详情
      productType: 0,
      //酒店类型
      isSub: false,
      //佣金设置是否单独设置
      addType: 'isAdd'
    };
  },
  computed: _objectSpread({
    ProductTypeEnum: function ProductTypeEnum() {
      return _productEnums.ProductTypeEnum;
    },
    //操作上下架禁用
    IsShow: function IsShow() {
      return this.tableFrom.type == _productEnums.ProductTypeEnum.RecycleBin || this.tableFrom.type == _productEnums.ProductTypeEnum.Audit || this.tableFrom.type == _productEnums.ProductTypeEnum.ReviewFailed || this.tableFrom.type == _productEnums.ProductTypeEnum.PendingReview;
    },
    //已售罄或者警戒面积
    SoldOutAndAlertInventory: function SoldOutAndAlertInventory() {
      return this.tableFrom.type == this.ProductTypeEnum.SoldOut || this.tableFrom.type == this.ProductTypeEnum.AlertInventory;
    },
    //已售罄、警戒面积操作判断
    operation: function operation() {
      return this.tableFrom.type == this.ProductTypeEnum.SoldOut || this.tableFrom.type == this.ProductTypeEnum.AlertInventory;
    },
    //加入回收站 操作
    RecycleBin: function RecycleBin() {
      return this.tableFrom.type == this.ProductTypeEnum.Audit || this.tableFrom.type == this.ProductTypeEnum.ReviewFailed || this.tableFrom.type === _productEnums.ProductTypeEnum.InTheWarehouse || this.tableFrom.type === _productEnums.ProductTypeEnum.PendingReview;
    }
  }, (0, _vuex.mapGetters)(['merPlatProductClassify', 'merProductClassify', 'productBrand', 'shippingTemplates'])),
  activated: function activated() {
    // this.goodHeade();
    this.getList(1);
  },
  mounted: function mounted() {
    this.getRoomTypeOptionsApi();
    // if (checkPermi(['merchant:product:tabs:headers'])) this.goodHeade();
    if ((0, _permission.checkPermi)(['merchant:product:page:list'])) this.getList();
    if (!localStorage.getItem('shippingTemplates')) this.$store.dispatch('product/getShippingTemplates');
    this.checkedCities = this.$cache.local.has('goods_stroge') ? this.$cache.local.getJSON('goods_stroge') : this.checkedCities;
    //this.$store.dispatch('product/getAdminProductClassify');
    this.$store.dispatch('product/getAdminProductClassify');
    if (!localStorage.getItem('merProductClassify')) this.$store.dispatch('product/getMerProductClassify');
    this.$store.dispatch('product/getMerProductBrand');
  },
  methods: {
    checkPermi: _permission.checkPermi,
    //提交审核
    handlePendingReview: function handlePendingReview(row) {
      var _this2 = this;
      if (!row && this.checkedIds.length === 0) return this.$message.warning('请至少选择一个酒店');
      if (!row) {
        this.$modalSure("\u786E\u5B9A\u8981\u5C06\u6B64\u9152\u5E97\u63D0\u4EA4\u5E73\u53F0\u5BA1\u6838\u5417\uFF1F").then(function () {
          (0, _product.productBatchAuditApi)({
            idList: _this2.checkedIds
          }).then(function () {
            _this2.$message.success('批量提交审核成功');
            _this2.getList('');
            // this.goodHeade();
          });
        });
      } else {
        this.$confirm('提审之后是否自动上架？', '提示', {
          confirmButtonText: '上架',
          cancelButtonText: '不用了',
          type: 'warning',
          distinguishCancelAndClose: true,
          closeOnClickModal: false,
          customClass: 'deleteConfirm'
        }).then(function () {
          _this2.productAudit({
            id: row.id,
            isAutoUp: true
          });
        }).catch(function (action) {
          if (action === 'cancel') {
            _this2.productAudit({
              id: row.id,
              isAutoUp: false
            });
            // 调用取消按钮的方法
          } else if (action === 'close') {
            console.log('Closed');
            // 调用关闭按钮的方法
          }
        });
      }
    },
    // 获取房型列表
    getRoomTypeOptionsApi: function getRoomTypeOptionsApi() {
      var _this3 = this;
      (0, _hotel.roomTypeOptionsApi)().then(function (res) {
        console.log('获取房型列表', res);
        _this3.roomTypeOptions = res;
      });
    },
    //提审提交
    productAudit: function productAudit(data) {
      var _this4 = this;
      (0, _product.productAuditApi)(data).then(function (res) {
        // this.goodHeade();
        _this4.getList();
      });
    },
    //批量加入回收站
    handleRecycleBin: function handleRecycleBin(type) {
      var _this5 = this;
      if (this.checkedIds.length === 0) return this.$message.warning('请至少选择一个酒店');
      this.$modalSure(type == 5 ? "\u786E\u5B9A\u6279\u91CF\u5220\u9664\u9152\u5E97\u5417\uFF1F" : "\u786E\u5B9A\u6279\u91CF\u52A0\u5165\u56DE\u6536\u7AD9\u5417\uFF1F").then(function () {
        if (type == 5) {
          _this5.onBatchDelete();
        } else {
          _this5.onBatchRecycle();
        }
      });
    },
    handleGenerateInventory: function handleGenerateInventory(row) {
      var _this6 = this;
      var id = row.id,
        roomTypeName = row.roomTypeName;
      console.log(row);
      this.$modalSure('对于当前房型: [' + roomTypeName + ' ] 确定生成库存吗').then(function () {
        (0, _hotel.generateInventory)({
          id: id
        }).then(function (res) {
          _this6.$message.success('库存生成成功');
          _this6.getList();
        });
      });
    },
    //批量删除
    onBatchDelete: function onBatchDelete() {
      var _this7 = this;
      (0, _product.productBatchDeleteApi)({
        idList: this.checkedIds
      }).then(function () {
        _this7.$message.success('批量删除成功');
        _this7.tableFrom.page = _this7.tableFrom.page - 1;
        _this7.delSuccess();
      });
    },
    //批量加入回收站
    onBatchRecycle: function onBatchRecycle() {
      var _this8 = this;
      (0, _product.productBatchRecycleApi)({
        idList: this.checkedIds
      }).then(function () {
        _this8.$message.success('批量加入回收站成功');
        _this8.tableFrom.page = _this8.tableFrom.page - 1;
        _this8.delSuccess();
      });
    },
    // 删除成功
    delSuccess: function delSuccess() {
      (0, _public.handleDeleteTable)(this.tableData.data.length, this.tableFrom);
      this.getList();
      // this.goodHeade();
    },
    //添加回馈券
    handleAddCoupon: function handleAddCoupon(row) {
      this.productInfo = row;
      if (!row && this.checkedIds.length === 0) return this.$message.warning('请至少选择一个酒店');
      var _this = this;
      this.$modalCoupon('wu', _this.keyNum += 1, [], function (row) {
        row.map(function (item) {
          _this.couponIds.push(item.id);
        });
        _this.onSetCoupons(_this.couponIds);
      }, '');
    },
    //设置优惠券提交
    onSetCoupons: function onSetCoupons(couponIds) {
      var _this9 = this;
      if (this.productInfo) {
        (0, _product.productAddCouponsApi)({
          id: this.productInfo.id,
          couponIds: couponIds
        }).then(function () {
          _this9.$message.success('添加回馈券成功');
        });
      } else {
        (0, _product.productBatchAddCouponsApi)({
          idList: this.checkedIds,
          couponIds: couponIds
        }).then(function () {
          _this9.$message.success('批量添加回馈券成功');
        });
      }
    },
    // 设置运费
    handleSetFreight: function () {
      var _handleSetFreight = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(row) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.productInfo = row;
              if (!(!row && this.checkedIds.length === 0)) {
                _context.n = 1;
                break;
              }
              return _context.a(2, this.$message.warning('请至少选择一个酒店'));
            case 1:
              this.dialogVisible = true;
              if (row) this.formValidate.tempId = row.tempId;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function handleSetFreight(_x) {
        return _handleSetFreight.apply(this, arguments);
      }
      return handleSetFreight;
    }(),
    //设置运费提交
    handleSubmit: function handleSubmit(name) {
      var _this0 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this0.loadingBtn = true;
          if (_this0.productInfo) {
            (0, _product.productSetFreightApi)({
              id: _this0.productInfo.id,
              templateId: _this0.formValidate.tempId
            }).then(function () {
              _this0.loadingBtn = false;
              _this0.$message.success('设置运费模板成功');
              _this0.dialogVisible = false;
            }).catch(function () {
              _this0.loadingBtn = false;
            });
          } else {
            (0, _product.productBatchFreightApi)({
              idList: _this0.checkedIds,
              templateId: _this0.formValidate.tempId
            }).then(function () {
              _this0.loadingBtn = false;
              _this0.$message.success('批量设置运费模板成功');
              _this0.dialogVisible = false;
            }).catch(function () {
              _this0.loadingBtn = false;
            });
          }
        }
      });
    },
    //取消运费
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.formValidate.tempId = '';
    },
    //设置佣金
    handleSetCommission: function handleSetCommission(row) {
      this.productInfo = row;
      if (!row && this.checkedIds.length === 0) return this.$message.warning('请至少选择一个酒店');
      this.dialogCommision = true;
    },
    //设置佣金提交
    submitCommisionForm: function submitCommisionForm(name) {
      var _this1 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          if (_this1.productInfo) {
            _this1.commisionForm.id = _this1.productInfo.id;
            (0, _product.productBrokerageApi)(_this1.commisionForm).then(function () {
              _this1.$message.success('设置佣金成功');
              _this1.dialogCommision = false;
            });
          } else {
            _this1.commisionForm.idList = _this1.checkedIds;
            (0, _product.productBatchBrokerageApi)(_this1.commisionForm).then(function () {
              _this1.$message.success('批量设置佣金成功');
              _this1.dialogCommision = false;
            });
          }
        } else {
          return;
        }
      });
    },
    //添加酒店
    handleAdd: function handleAdd(type) {
      var addType = this.addType === 'isAdd' ? 2 : 1;
      //id:酒店id，isDisabled：是否能编辑(1不能，2能)，isCopy：是否是采集酒店(1是，2不是)
      this.$router.push({
        path: "/hotel/list/creatProduct/0/2/".concat(addType)
      });
    },
    //批量下架
    batchDelisting: function batchDelisting(type) {
      var _this10 = this;
      if (this.checkedIds.length === 0) return this.$message.warning('请至少选择一个酒店');
      if (type === 'down') {
        this.$modalSure('确定要将选中酒店批量下架吗?').then(function () {
          (0, _product.productBatchDownApi)({
            idList: _this10.checkedIds
          }).then(function () {
            _this10.$message.success('批量下架成功');
            _this10.getList(1);
            // this.goodHeade();
          });
        });
      } else {
        this.$modalSure('确定要将选中酒店批量上架吗?').then(function () {
          (0, _product.productBatchUpApi)({
            idList: _this10.checkedIds
          }).then(function () {
            _this10.$message.success('批量上架成功');
            _this10.getList(1);
            // this.goodHeade();
          });
        });
      }
    },
    // 设置选中的方法
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelectionAll = val;
      var data = [];
      this.multipleSelectionAll.map(function (item) {
        data.push(item.id);
      });
      this.checkedIds = data;
    },
    selectAll: function selectAll(data) {
      var id = data.map(function (i, index) {
        return i.id;
      });
      this.checkedIds = Array.from(new Set([].concat(_toConsumableArray(this.checkedIds), _toConsumableArray(id))));
    },
    selectOne: function selectOne(data, row) {
      var id = data.map(function (i, index) {
        return i.id;
      });
      var index = this.checkedIds.findIndex(function (e) {
        return e == row.id;
      });
      this.checkedIds.splice(index, 1);
      this.checkedIds = Array.from(new Set([].concat(_toConsumableArray(this.checkedIds), _toConsumableArray(id))));
    },
    //编辑酒店
    onEdit: function onEdit(row) {
      var _this11 = this;
      //id:酒店id，isDisabled：是否能编辑(1不能，2能)，isCopy：是否是采集酒店(1是，2不是)
      if (this.tableFrom.type === '1') {
        this.$modalSure('下架该酒店吗？出售酒店需下架之后可编辑。').then(function () {
          (0, _product.offShellApi)(row.id).then(function () {
            _this11.$router.push({
              path: "/hotel/list/creatProduct/".concat(row.id, "/2/2/").concat(row.type)
            });
          });
        });
      } else {
        this.$router.push({
          path: "/hotel/list/creatProduct/".concat(row.id, "/2/2/").concat(row.type)
        });
      }
    },
    handleCloseEdit: function handleCloseEdit() {
      this.drawer = false;
    },
    handleAudit: function handleAudit(id) {
      var _this12 = this;
      // this.$modalSure('提审酒店吗').then(() => {
      //   productAuditApi(id).then((res) => {
      //     this.goodHeade();
      //     this.getList();
      //   });
      // });
      this.$confirm('提审之后是否自动上架？', '提示', {
        confirmButtonText: '上架',
        cancelButtonText: '不用了',
        type: 'warning',
        showClose: false,
        closeOnClickModal: false
      }).then(function () {
        _this12.productAudit({
          id: id,
          isAutoUp: true
        });
      }).catch(function () {
        _this12.productAudit({
          id: id,
          isAutoUp: false
        });
      });
    },
    handleSeachList: function handleSeachList() {
      this.getList(1);
      // this.goodHeade();
    },
    //重置
    handleReset: function handleReset() {
      this.tableFrom.cateId = '';
      this.tableFrom.keyword = '';
      this.tableFrom.categoryId = '';
      this.tableFrom.isPaidMember = null;
      this.tableFrom.productType = null;
      this.keyword = '';
      this.handleSeachList();
    },
    // 导出
    exports: function exports() {
      (0, _product.productExcelApi)({
        cateId: this.tableFrom.cateId,
        keyword: this.tableFrom.keyword,
        type: this.tableFrom.type
      }).then(function (res) {
        window.location.href = res.fileName;
      });
    },
    // 获取酒店表单头数量
    // goodHeade() {
    //   let data = Object.assign({}, this.tableFrom);
    //   delete data.page;
    //   delete data.limit;
    //   delete data.type;
    //   productHeadersApi(data)
    //     .then((res) => {
    //       res.map((item) => {
    //         item.name = objTitle[Number(item.type) - 1];
    //       });
    //       this.headeNum = res;
    //     })
    //     .catch((res) => {
    //       this.$message.error(res.message);
    //     });
    // },
    changeNodes: function changeNodes(data) {
      if (data.length > 0) {
        for (var i = 0; i < data.length; i++) {
          if (!data[i].childList || data[i].childList.length < 1) {
            data[i].childList = undefined;
          } else {
            this.changeNodes(data[i].childList);
          }
        }
      }
      return data;
    },
    // 列表
    getList: function getList(num) {
      var _this13 = this;
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      this.tableFrom.keyword = encodeURIComponent(this.keyword);
      this.tableFrom.areae = this.tableFrom.areae;
      (0, _hotel.hotelLstApi)(this.tableFrom).then(function (res) {
        _this13.tableData.data = res.list;
        _this13.tableData.total = res.total;
        _this13.listLoading = false;
      }).catch(function (res) {
        _this13.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    //详情
    handleInfo: function handleInfo(id, type) {
      this.$router.push({
        path: "/product/list/creatProduct/".concat(id, "/2/2/").concat(type)
      });
    },
    // 删除
    handleDelete: function handleDelete(id, type) {
      var _this14 = this;
      this.$modalSure(type == 5 ? "\u5220\u9664 id \u4E3A ".concat(id, " \u7684\u9152\u5E97") : "id\u4E3A".concat(id, "\u7684\u9152\u5E97\u52A0\u5165\u56DE\u6536\u7AD9\u5417")).then(function () {
        var deleteFlag = type == 5 ? 'delete' : 'recycle';
        (0, _product.productDeleteApi)({
          id: id,
          type: deleteFlag
        }).then(function () {
          _this14.$message.success('删除成功');
          _this14.delSuccess();
        });
      });
    },
    onchangeIsShow: function onchangeIsShow(row) {
      var _this15 = this;
      row.isShow ? (0, _product.putOnShellApi)(row.id).then(function () {
        _this15.$message.success('上架成功');
        _this15.getList(1);
        _this15.goodHeade();
      }).catch(function () {
        row.isShow = !row.isShow;
      }) : (0, _product.offShellApi)(row.id).then(function () {
        _this15.$message.success('下架成功');
        _this15.getList(1);
        _this15.goodHeade();
      }).catch(function () {
        row.isShow = !row.isShow;
      });
    },
    handleAddItem: function handleAddItem() {
      if (this.card_select_show) {
        this.$set(this, 'card_select_show', false);
      } else if (!this.card_select_show) {
        this.$set(this, 'card_select_show', true);
      }
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedCities = val ? this.columnData : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.columnData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnData.length;
    },
    checkSave: function checkSave() {
      this.$set(this, 'card_select_show', false);
      this.$modal.loading('正在保存到本地，请稍候...');
      this.$cache.local.setJSON('goods_stroge', this.checkedCities);
      setTimeout(this.$modal.closeLoading(), 1000);
    },
    // 监听新增数据， 刷新列表
    handleSuccess: function handleSuccess() {
      console.log('新增成功,刷新列表');
    }
  }
};